export default {
  users: null,
  loading: false,
}
